import { isProduction } from '@vp/digital-environment-lib-ubik'
import { PersonalizeHeroImageResponse } from '../types/Types'
import { PersonalizedImageTemplateKeys } from '../../../enums/personalizedImageTemplateKeys'

const PERSONALIZED_IMAGE_SERVICE_PROD_HOST = 'https://prod.personalization-service-api.digital.vistaprint.io/'

const PERSONALIZED_IMAGE_SERVICE_QA_HOST = 'https://qa.personalization-service-api.digital.vistaprint.io/'

export const getPersonalizedImageServiceHost = (): string => {
  return isProduction() ? PERSONALIZED_IMAGE_SERVICE_PROD_HOST : PERSONALIZED_IMAGE_SERVICE_QA_HOST
}

export const fetchPersonalizedHeroImage = async (auth: any, template: PersonalizedImageTemplateKeys, locale: string): Promise<PersonalizeHeroImageResponse> => {
  const response = await fetch(`${getPersonalizedImageServiceHost()}personalize/image?getDomain=false`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.getAuthorizationHeader(),
    },
    body: JSON.stringify({
      template,
      locale,
    }),
  })

  if (!response.ok) {
    throw new Error(`Error: ${response.status}`)
  }

  const result = await response.json()
  return result
}
